import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DoctorsModel } from 'src/app/models/DoctorsModel';
import { ReportFromToComponent } from '../report-from-to/report-from-to.component';
import { LocalStorageService } from 'ngx-webstorage';
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-report-pharma',
  templateUrl: './report-pharma.component.html',
  styleUrls: ['./report-pharma.component.css']
})
export class ReportPharmaComponent implements OnInit {
  ReportURL0 =  'CocReports/PreparationByPat';
  ReportURL1 =  'CocReports/PreparationByDate';
  ReportURL2 =  'CocReports/PreparationByProtocol';
  ReportURL22 =  'CocReports/ItemsList';
  ReportURL4 =  'CocReports/SavingByPatient';
  ReportURL44 =  'CocReports/Protocols';
  ReportURL5 =  'CocReports/SavingByDrug';
  PatientCode ='';
  fromDate='';
  toDate='';
  fromDateD = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  toDateD = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  screenTitle ='';
  protocol ='';
  constructor(public route: Router,
    private dialogref: MatDialog,
    private prepHDSelecteData:DoctorsModel,
    public storage: LocalStorageService,
    public doctorSelectedData: DoctorsModel) { }

  ngOnInit(): void {
  }
  openDialog_0(){
    this.screenTitle ='Patient preparation order by patient';
    const dialogRef = this.dialogref.open(ReportFromToComponent,
      {
        data:
          {dialogTitle: this.screenTitle, dialogText: 'Year_N-Date_N-Pat_Y-Doc_N-Butt_N-Room_N'}
      });
    dialogRef.afterClosed().subscribe(result => {
    });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {

        this.fromDate = result.patientFName ;
        this.toDate = result.birthDate;
        this.fromDateD = result.telHome;
        this.toDateD = result.patientFullName;
        this.PatientCode = result.patientCode;
          console.log("docAddress ", this.fromDateD + "   result.patientFullName :" + result.patientFullName  );

        dialogSubmitSubscription.unsubscribe();
        this.storage.store('stgParD1', this.fromDateD);
        this.storage.store('stgParD2', this.toDateD);
        this.storage.store('stgParD3', this.PatientCode);

        console.log("stgParD1 ",this.storage.retrieve('stgParD2'));

        this.route.navigate(['report-vewier', this.ReportURL0]);

      });
  }
  openDialog_00(){
    this.screenTitle ='Saving Drugs By Patient From Date To Date';
    const dialogRef = this.dialogref.open(ReportFromToComponent,
      {
        data:
          {dialogTitle: this.screenTitle, dialogText: 'Year_N-Date_Y-Pat_Y-Doc_N-Butt_N-Room_N'}
      });
    dialogRef.afterClosed().subscribe(result => {
    });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {

        this.fromDate = result.patientFName ;
        this.toDate = result.birthDate;
        this.fromDateD = result.telHome;
        this.toDateD = result.patientFullName;
        this.PatientCode = result.patientCode;

        dialogSubmitSubscription.unsubscribe();
        this.storage.store('stgParD1', this.fromDateD);
        this.storage.store('stgParD2', this.toDateD);
        this.storage.store('stgParD3', this.PatientCode);

        this.route.navigate(['report-vewier', this.ReportURL4]);

      });
  }
  openDialog_1(){
    this.screenTitle ='Patient preparation order by Date';

    const dialogRef = this.dialogref.open(ReportFromToComponent,
      {
        data:
          {dialogTitle: this.screenTitle, dialogText: 'Year_N-Date_Y-Pat_N-Doc_N-Butt_Y-Room_N'}
      });
    dialogRef.afterClosed().subscribe(result => {
    });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {

        this.fromDate = result.docName;
        this.toDate = result.docTitle;
        this.fromDateD = result.docWMMobile;
        this.toDateD = result.docWmail;

        dialogSubmitSubscription.unsubscribe();
        this.storage.store('stgParD1', this.fromDateD);
        this.storage.store('stgParD2', this.toDateD);

        console.log("stgParD1 ",this.storage.retrieve('stgParD2'));

        this.route.navigate(['report-vewier', this.ReportURL1]);

      });
  }
  openDialog_10(){
    this.screenTitle ='Saving Drugs By Item From Date To Date';

    const dialogRef = this.dialogref.open(ReportFromToComponent,
      {
        data:
          {dialogTitle: this.screenTitle, dialogText: 'Year_N-Date_Y-Pat_N-Doc_N-Butt_Y-Room_N'}
      });
    dialogRef.afterClosed().subscribe(result => {
    });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {

        this.fromDate = result.docName;
        this.toDate = result.docTitle;
        this.fromDateD = result.docWMMobile;
        this.toDateD = result.docWmail;

        dialogSubmitSubscription.unsubscribe();
        this.storage.store('stgParD1', this.fromDateD);
        this.storage.store('stgParD2', this.toDateD);

        console.log("stgParD1 ",this.storage.retrieve('stgParD2'));

        this.route.navigate(['report-vewier', this.ReportURL5]);

      });
  }
  openDialog_11(){
    this.screenTitle ='Saving Drugs By Patient From Date To Date (Detailed)';

    const dialogRef = this.dialogref.open(ReportFromToComponent,
      {
        data:
          {dialogTitle: this.screenTitle, dialogText: 'Year_N-Date_Y-Pat_N-Doc_N-Butt_Y-Room_N'}
      });
    dialogRef.afterClosed().subscribe(result => {
    });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {

        this.fromDate = result.docName;
        this.toDate = result.docTitle;
        this.fromDateD = result.docWMMobile;
        this.toDateD = result.docWmail;

        dialogSubmitSubscription.unsubscribe();
        this.storage.store('stgParD1', this.fromDateD);
        this.storage.store('stgParD2', this.toDateD);
        this.storage.store('stgParD3', '');



        this.route.navigate(['report-vewier', this.ReportURL4]);

      });
  }
  openDialog_2(){
    this.screenTitle ='Drug circulation report by protocols';

    const dialogRef = this.dialogref.open(ReportFromToComponent,
      {
        data:
          {dialogTitle: this.screenTitle, dialogText: 'Year_N-Date_Y-Pat_N-Doc_N-Butt_Y-Room_N-Proto_Y'}
      });
    dialogRef.afterClosed().subscribe(result => {
    });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {

        this.fromDate = result.docName;
        this.toDate = result.docTitle;
        this.fromDateD = result.docWMMobile;
        this.toDateD = result.docWmail;
        this.protocol = result.docPhone;
        dialogSubmitSubscription.unsubscribe();
        this.storage.store('stgParD1', this.fromDateD);
        this.storage.store('stgParD2', this.toDateD);
        this.storage.store('stgParProtocol', this.protocol);

        console.log("stgParD1 ",this.storage.retrieve('stgParD2'));

        this.route.navigate(['report-vewier', this.ReportURL2]);

      });
  }
  ReportProtocols(){
    this.route.navigate(['report-vewier', this.ReportURL44]);
  }
  ReportItems(){
    this.route.navigate(['report-vewier', this.ReportURL22]);
  }
}
